import API from 'js/lib/api';

const emailVerificationUtils = {
  verifyEmailToken(token: string) {
    const api = API('/api/grpc/useremails/v1/UserEmailsAPI', {
      type: 'rest',
    });
    const data = { token };
    return Promise.resolve(api.post('VerifyUserEmail', { data }));
  },
  verifyRecoveryEmailToken(token: string) {
    const api = API('/api/grpc/useremails/v1/RecoveryEmailsAPI', {
      type: 'rest',
    });
    const data = { token };
    return Promise.resolve(api.post('VerifyRecoveryEmail', { data }));
  },
};

/* Commonly misspelled domains taken from this audit: https://docs.google.com/spreadsheets/d/1-DRxSFAAArN5-5Le6xVPcoi3drXU55VjU4d6HYY0IiY/edit#gid=549105264 */
// see also: https://coursera.atlassian.net/wiki/spaces/GROW/pages/1607762372/Email+Domain+Validation+on+Signup
export const isMisspelledDomain = (
  domain: string,
  { checkOnlyGmail }: { checkOnlyGmail: boolean } = { checkOnlyGmail: false }
): boolean => {
  const validPrefixes = checkOnlyGmail ? ['gmail'] : ['gmail', 'yahoo', 'hotmail'];

  // These are definitely valid, short circuit and return right away
  if (validPrefixes.map((prefix) => `${prefix}.com`).includes(domain)) return false;

  // Gmail has always kept one global domain: @gmail.com
  // Allow country-level domains for Hotmail and Yahoo (e.g., hotmail.co.uk, yahoo.com.br)
  const gmailWithExtraCharacters = new RegExp('gmail.com(.+)', 'g');
  if (gmailWithExtraCharacters.test(domain)) return true;

  const [prefix] = domain.split('.', 1);
  // We don't want to let through any gmail address with a weird suffix
  if (prefix === 'gmail') return true;

  // Allow country-level domains for Hotmail and Yahoo
  let isInvalidDomainStructure = false;
  if (!checkOnlyGmail) {
    if (prefix === 'hotmail' || prefix === 'yahoo') {
      // Validate the domain structure (e.g., hotmail.com, hotmail.co.uk, yahoo.com.br)
      const validDomainPattern = /^(hotmail|yahoo)\.[a-z]{2,3}(\.[a-z]{2})?$/i;
      if (!validDomainPattern.test(domain)) isInvalidDomainStructure = true;
    }
  }

  const MISTYPED_GMAIL = [
    'gail.com',
    'gamail.com',
    'gamil.com',
    'gemail.com',
    'gmai.com',
    'gmail.com',
    'gmaill.com',
    'gmial.com',
    'gmsil.com',
    'gnail.com',
  ];

  const MISTYPED_HOTMAIL = ['htmail.com'];

  const MISTYPED_YAHOO = ['yahoo.con', 'yahoo.co'];

  const MISTYPED_ALL = checkOnlyGmail ? MISTYPED_GMAIL : [...MISTYPED_GMAIL, ...MISTYPED_HOTMAIL, ...MISTYPED_YAHOO];

  return MISTYPED_ALL.includes(domain) || isInvalidDomainStructure;
};
export const { verifyEmailToken, verifyRecoveryEmailToken } = emailVerificationUtils;

export default emailVerificationUtils;
